export enum TypeCards {
  Eau = "Eau",
  CatastropheNaturelle = "Catastrophe naturelles",
  DPE = "DPE batiment",
  InstallationClasse = "Installation dangeureuse",
  ParcNaturelle = "Par naturelle",
  RisqueLocaux = "Risque de l'adresse",
  ZoneInnondable = "Risque d'innondation",
  PollutionSol = "Pollution des sols",
  RisqueInforamtion = "Information sur les risques",
}
